import { FormKit } from "@formkit/vue";
import { Btn2, btn2_redEnabledClasses } from "src/components/UserInterface/Btn2";
import { SuggestedTeamAssignmentsOptions } from "src/composables/InleagueApiV1.Teams";
import { assertTruthy, vReqT } from "src/helpers/utils";
import { User } from "src/store/User";
import { defineComponent } from "vue";

export const AutoAssignModal = defineComponent({
  props: {
    opts: vReqT<SuggestedTeamAssignmentsOptions>(),
  },
  emits: {
    "submit": () => true,
    "cancel": () => true,
  },
  setup(props, ctx) {
    const FormkitishLabelText = defineComponent({setup(_, ctx) {
      return () => <div class="formkit-label" style="padding: 0; font-weight: var(--fk-font-weight-option); font-size: var(--fk-font-size-option);">
        {ctx.slots.default?.()}
      </div>
    }})
    return () => {
      return <div style="--fk-margin-outer: none; --fk-padding-input: .35em;">
        <div class="my-2 text-sm">
          The auto-assign tool is intended as a "first pass" utility to distribute players to teams according to their historical ratings and the below options. Proposed assignments are displayed in the team assignment tool and can be adjusted prior to saving.
        </div>
        <FormKit type="form" actions={false} onSubmit={() => ctx.emit("submit")}>
          <div class="my-2">
            <FormKit type="checkbox" v-model={props.opts.useWaitlist} label="Include Waitlisted Players"/>
          </div>
          <div class="my-2">
            <FormKit type="checkbox" v-model={props.opts.useRecentRating} label="Use most recent rating instead of lifetime rating"/>
          </div>
          <div class="my-2">
            <FormKit type="checkbox" v-model={props.opts.assignSiblings} label="Always assign siblings together"/>
          </div>
          <div class="my-2">
            <FormKit type="checkbox" v-model={props.opts.assignCoachesKids} label="Always place coach's players on coach's team"/>
          </div>
          <div class="my-2">
            <FormKit type="checkbox" v-model={props.opts.useAgeBalancing} label="Balance two-year divisions evenly"/>
          </div>
          {props.opts.schedulerVersion === "v2-optaplanner"
            ? <label class="my-2 flex items-center">
              <FormKit type="checkbox" v-model={props.opts.keepPlayersInSameSchoolTogether}/>
              <FormkitishLabelText>
                Keep players in same school together
                {/* explanatory text about 'schools must be exact string matches (case-insensitive)' ... ? */ }
              </FormkitishLabelText>
            </label>
            : null}
          <div class="my-2">
            <FormKit type="number" step="1" min="0" v-model={props.opts.numPerTeam} label="Desired # of players per team"/>
          </div>
          <div class="my-2">
            <FormKit type="number" step=".1" min="0" v-model={props.opts.unratedRating} label="Treat unrated players as having this rating"/>
          </div>
          {User.isInleague // for now we offer this il=1 users for dev purposes, otherwise the user gets no choice (it's whatever we initialize it to)
            ? <div class="my-2 rounded-md p-2 bg-black text-white">
              <div>
                Scheduler Algorithm
                {(() => {
                  assertTruthy(User.isInleague);
                  return " (il=1)"
                })()}
              </div>
              <label class="flex gap-2 items-center">
                <input type="radio" v-model={props.opts.schedulerVersion} value={"v2-optaplanner" satisfies SuggestedTeamAssignmentsOptions["schedulerVersion"]}/>
                <span>V2 - Introduced in May '25</span>
              </label>
              <label class="flex gap-2 items-center">
                <input type="radio" v-model={props.opts.schedulerVersion} value={"v1-cf" satisfies SuggestedTeamAssignmentsOptions["schedulerVersion"]}/>
                <span>V1 - Legacy Scheduler</span>
              </label>
            </div>
            : null}
          <div class="flex gap-2 mt-2">
            <Btn2 class="p-2" type="submit">OK</Btn2>
            <Btn2 class="p-2" enabledClasses={btn2_redEnabledClasses} onClick={() => ctx.emit("cancel")}>Cancel</Btn2>
          </div>
        </FormKit>
      </div>
    }
  }
})
